import React from 'react';
import {Slide} from "react-slideshow-image";

import {ReactComponent as ChevronLeft} from '../../../../../assets/icons/icon_chevron_left.svg';
import {ReactComponent as ChevronRight} from '../../../../../assets/icons/icon_chevron_right.svg';
import Image from "../../../../../networking/models/Image";

interface Props {
    images: Image[]
}

const UniversityGeneralImages: React.FC<Props> = ({images}) => {
    const properties = {
        prevArrow: <div className={"university-general__image-button"}><ChevronLeft/></div>,
        nextArrow: <div className={"university-general__image-button"}><ChevronRight/></div>,
    }

    return (
        <div className="university-general__images">
            <Slide transitionDuration={500} easing={'ease-out'} {...properties}>
                {
                    images.map((image, index) => (
                        <div
                            key={index}
                            className="university-general__image"
                            style={{'backgroundImage': `url(${image.url})` }} />
                    ))
                }
            </Slide>
        </div>
    )
}

export default UniversityGeneralImages;
